"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function removeEmptyElements(obj) {
    Object.entries(obj).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (value === null || value === undefined || value.length < 1) {
            delete obj[key];
        }
    });
}
exports.default = removeEmptyElements;
//# sourceMappingURL=removeEmptyElements.js.map